import React from "react";
import RadioButtonQuest from "../../../../UI/RadioButtonQuest";

const ExceedCreditLimit = ({ onselectAnswer, reff, display }) => {

    const optionHandle = async (e) => {
        onselectAnswer(e);
    }

    return (
        <>
            <div style={{ display: display }}>
                <div className="radio-box question animated fadeInUp" ref={reff}>
                    <h3>
                        Did you ever exceed your overdraft limit?
                    </h3>
                    <RadioButtonQuest
                        key="Yes"
                        className="radio-button"
                        labelName="Yes"
                        labelClassName="option_but next-2"
                        onClick={optionHandle}
                        value="247"
                        name="exceedCredLimit"
                        id="yes95"
                        dataQuestId={95}
                        dataAnsId={251}
                        dataAnsLabel="Yes"
                    />
                    <RadioButtonQuest
                        key="No"
                        className="radio-button"
                        labelName="No"
                        labelClassName="option_but next-2"
                        onClick={optionHandle}
                        value="248"
                        name="exceedCredLimit"
                        id="no95"
                        dataQuestId={95}
                        dataAnsId={252}
                        dataAnsLabel="No"
                    />
                </div>
            </div>
        </>
    );
};

export default ExceedCreditLimit;
